module.exports = __webpack_public_path__ + "static/media/white-eye.a0f4c595.svg";